import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { createFolder } from '~/generated';
import type { FolderCreated, FolderPurpose } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Payload = {
  parentFolderId: string;
  data: {
    name: string;
    purpose: FolderPurpose;
    contentExpirationInDays?: number | null;
  };
};

export const useCreateFolder = (
  options: UseMutationOptions<FolderCreated, unknown, Payload, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ parentFolderId, data }) =>
      extractData(
        createFolder({
          body: {
            name: data.name,
            purpose: data.purpose,
            contentExpirationInDays: data.contentExpirationInDays,
            parentFolderId: parentFolderId,
          },
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({ queryKey: ['document-share'] });
      options.onSuccess?.(...args);
    },
  });
};
